import { cn } from '@lensora/ui'
import * as React from 'react'

interface SuggestionChipsProps {
  options: string[]
  selected: (option: string) => boolean
  onToggle: (option: string) => void
  disabled?: boolean
}

export function SuggestionChips({ options, selected, onToggle, disabled }: SuggestionChipsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        const isSelected = selected(option)
        return (
          <button
            key={option}
            type="button"
            disabled={disabled}
            onClick={() => onToggle(option)}
            className={cn(
              'rounded-full border px-3.5 py-1.5 text-left text-xs font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60',
              isSelected
                ? 'border-brand-accent bg-brand-accent/10 text-brand-accent'
                : 'border-border text-text-muted hover:border-brand-accent/40 hover:text-text'
            )}
          >
            {option}
          </button>
        )
      })}
    </div>
  )
}
